exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".d-flex {display: flex;}\r\n.align-items-center{align-items:center;}\r\n.align-items-start{align-items:start;}\r\n.justify-content-center{justify-content: center;}\r\n.justify-content-between{justify-content: space-between;}\r\n.flex-direction-column{flex-direction: column};\r\n.mb-3 {margin-bottom: 1rem!important;}\r\n.modal-footer {padding: 15px;text-align: right;border-top: 1px solid #e5e5e5;}\r\n.modal-header::before, .modal-header::after{content: none}\r\n", ""]);

// exports
